/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1350
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.zh_hans = undefined
exports.zh_hans = {
  DUPLICATE_BLOCK: "复制",
  COPY_ALL: "复制所有积木（ %1 块）",
  ADD_COMMENT: "添加注释",
  REMOVE_COMMENT: "删除注释",
  DELETE_BLOCK: "删除积木块",
  DELETE_X_BLOCKS: "删除所有积木（ %1 块）",
  DELETE_ALL_BLOCKS: "删除所有 %1 块吗?",
  CLEAN_UP: "整理积木",
  COLLAPSE_BLOCK: "折叠积木块",
  COLLAPSE_ALL: "折叠所有积木",
  EXPAND_BLOCK: "展开积木块",
  EXPAND_ALL: "展开所有积木",
  UNDO: "撤销",
  REDO: "重做",
  PASTE: "粘贴",
  COPY_AND_PASTE: "复制并粘贴",
  GLOBAL_COMMENT: "添加全局注释",
  COMMENT: "注释",
  BLUE_COMMENT: "蓝色注释",
  GREEN_COMMENT: "绿色注释",
  YELLOW_COMMENT: "黄色注释",
  RED_COMMENT: "红色注释",
  DELETE_COMMENT: "删除注释",
  WHATS_THIS: "这是什么功能…",
  SAY_SOMETHING: "说些什么…",
  START_ON_CLICK: "%1 当 开始 被点击",
  START_ON_CLICK_2: "%1 当 开始 被点击 %2 %3",
  ON_RUNNING_GROUP_ACTIVATED: "%1 当 切换到 当前屏幕",
  SELF_LISTEN: "%1 当 收到 广播 %2 %3 %4",
  SELF_BROADCAST: "发送广播 %1",
  SELF_BROADCAST_AND_WAIT: "发送广播 %1 并等待",
  WHEN: "%1 当 %2 %3",
  TERMINATE: "停止",
  REPEAT_FOREVER: "重复执行 %1 %2",
  REPEAT_N_TIMES: "重复执行 %1 次 %2 %3",
  REPEAT_FOREVER_UNTIL: "重复执行直到 %1 %2 %3",
  BREAK: "退出循环",
  WARP: "一步执行 %1 %2",
  WAIT_SECS: "等待 %1 秒",
  WAIT_UNTIL: "保持等待直到 %1",
  DESTRUCT: "销毁自身",
  CONTROLS_IF_MSG_IF: "如果",
  CONTROLS_IF_MSG_ELSEIF: "否则如果",
  CONTROLS_IF_MSG_ELSE: "否则",
  CONTROLS_IF_TOOLTIP_1: "如果值为真，执行一些语句。",
  CONTROLS_IF_TOOLTIP_2: "如果值为真，则执行第一块语句。否则，则执行第二块语句。",
  CONTROLS_IF_TOOLTIP_3: "如果第一个值为真，则执行第一块的语句。否则，如果第二个值为真，则执行第二块的语句。",
  CONTROLS_IF_TOOLTIP_4: "如果第一个值为真，则执行第一块对语句。否则，如果第二个值为真，则执行语句的第二块。如果没有值为真，则执行最后一块的语句。",
  TELL: "告诉 %1 执行 %2 %3",
  SYNC_TELL: "告诉 %1 执行并等待 %2 %3",
  GET_TIME: "当前 %1",
  YEAR: "年",
  MONTH: "月",
  DATE: "日",
  WEEK: "星期",
  WEEK0: "星期日",
  WEEK1: "星期一",
  WEEK2: "星期二",
  WEEK3: "星期三",
  WEEK4: "星期四",
  WEEK5: "星期五",
  WEEK6: "星期六",
  HOUR: "小时",
  MINUTE: "分钟",
  SECOND: "秒",
  TIMER: "计时器",
  RESET_TIMER: "重置 计时器",
  MATH_NUMBER_TOOLTIP: "一个数字。",
  RANDOM_NUM: "在 %1 到 %2 间随机整数",
  DIVISIBLE_BY: "%1 能被 %2 整除",
  CALCULATE: "数学运算 %1",
  CALCULATE_TOOLTIPS: "直接输入数学式子进行运算",
  MATH_ARITHMETIC: "%1 %2 %3",
  MATH_ARITHMETIC_TOOLTIP_ADD: "返回两个数值的和。",
  MATH_ARITHMETIC_TOOLTIP_MINUS: "返回两个数值的差值。",
  MATH_ARITHMETIC_TOOLTIP_MULTIPLY: "返回两个数值的乘积。",
  MATH_ARITHMETIC_TOOLTIP_DIVIDE: "返回两个数值的商。",
  MATH_ARITHMETIC_TOOLTIP_POWER: "返回以第一个数值为底数，以第二个数值为幂的结果。",
  MATH_SINGLE: "%1 %2",
  MATH_SINGLE_OP_ROOT: "算术平方根",
  MATH_SINGLE_TOOLTIP_ROOT: "返回一个数的平方根。",
  MATH_SINGLE_OP_ABSOLUTE: "绝对值",
  MATH_SINGLE_TOOLTIP_ABS: "返回一个数的绝对值。",
  MATH_SINGLE_TOOLTIP_NEG: "返回指定數字的逻辑非",
  MATH_SINGLE_TOOLTIP_LN: "返回一个数的自然对数。",
  MATH_SINGLE_TOOLTIP_LOG10: "返回一个数的对数。",
  MATH_SINGLE_TOOLTIP_EXP: "返回指定數字指數的 e",
  MATH_SINGLE_TOOLTIP_POW10: "返回一个数的10次幂。",
  MATH_ROUND: "%1 %2",
  MATH_ROUND_TOOLTIP: "数字向上或向下舍入。",
  MATH_ROUND_OPERATOR_ROUND: "四舍五入",
  MATH_ROUND_OPERATOR_ROUNDUP: "向上舍入",
  MATH_ROUND_OPERATOR_ROUNDDOWN: "向下舍入",
  MATH_MODULO_TITLE: "%1 ÷ %2 的余数",
  MATH_MODULO_TOOLTIP: "返回这两个数字相除后的余数。",
  MATH_NUMBER_PROPERTY: "%1 %2",
  MATH_IS_EVEN: "是偶数",
  MATH_IS_ODD: "是奇数",
  MATH_IS_PRIME: "是质数",
  MATH_IS_WHOLE: "是整数",
  MATH_IS_POSITIVE: "是正数",
  MATH_IS_NEGATIVE: "是负数",
  MATH_IS_TOOLTIP: "如果数字是偶数、奇数、非负整数、正数、负数或如果它可被某数字整除，则返回真或假。",
  MATH_DEGREES: "度",
  LOGIC_NEGATE_TITLE: "%1 不成立",
  LOGIC_BOOLEAN_TRUE: "成立",
  LOGIC_BOOLEAN_FALSE: "不成立",
  LOGIC_BOOLEAN_TOOLTIP: "返回真或假。",
  LOGIC_COMPARE: "%1 %2 %3",
  LOGIC_COMPARE_TOOLTIP_EQ: "如果两个输入结果相等，则返回真。",
  LOGIC_COMPARE_TOOLTIP_NEQ: "如果两个输入结果不相等，则返回真。",
  LOGIC_COMPARE_TOOLTIP_LT: "如果第一个输入结果比第二个小，则返回真。",
  LOGIC_COMPARE_TOOLTIP_LTE: "如果第一个输入结果小于或等于第二个输入结果，则返回真。",
  LOGIC_COMPARE_TOOLTIP_GT: "如果第一个输入结果比第二个大，则返回真。",
  LOGIC_COMPARE_TOOLTIP_GTE: "如果第一个输入结果大于或等于第二个输入结果，则返回真。",
  LOGIC_OPERATION: "%1 %2 %3",
  LOGIC_OPERATION_AND: "且",
  LOGIC_OPERATION_OR: "或",
  LOGIC_OPERATION_TOOLTIP_AND: "如果两个输入结果都为真，则返回真。",
  LOGIC_OPERATION_TOOLTIP_OR: "如果至少有一个输入结果为真，则返回真。",
  TEXT_TEXT_TOOLTIP: "一个字母、单词或一行文本。",
  TEXT_SELECT: "%1 的第 %2 到第 %3 个字符",
  TEXT_LENGTH: "%1 的长度",
  TEXT_CONTAIN: "%1 包含 %2",
  TEXT_SPLIT: "把 %1 按 %2 分开成列表",
  TEXT_JOIN_TOOLTIP: "通过串起任意数量的项以建立一段文字。",
  TEXT_JOIN_TITLE_HEAD: "把",
  TEXT_JOIN_TITLE_TAIL: "放在一起",
  VARIABLES_GET: "%1",
  VARIABLES_SET: "设置变量 %1 的值为 %2",
  CHANGE_VARIABLE: "将变量 %1 %2 %3",
  INCREASE: "增加",
  DECREASE: "减少",
  LISTS_GET: "%1",
  LISTS_APPEND: "添加 %1 到 %2 末尾",
  LISTS_INSERT_VALUE: "插入 %3 到 %1 的第 %2 项",
  LISTS_COPY: "复制 %2 到 %1",
  LISTS_LENGTH: "%1 的长度",
  LISTS_IS_EXIST: "%1 中包含 %2",
  LISTS_INDEX_OF: "%2 中第一个 %1 的位置",
  PROCEDURES_PARAMETER: "参数%1",
  PROCEDURES_RETURN_VALUE: "返回 %1 %2",
  PROCEDURES_DEFNORETURN_TITLE: "定义函数",
  PROCEDURES_DEFNORETURN_PROCEDURE: "函数",
  PROCEDURES_DEFNORETURN_TOOLTIP: "创建一个函数。",
  PROCEDURES_DEFRETURN_RETURN: "返回",
  COLOR_PICKER: "%1",
  RED: "红色",
  GREEN: "绿色",
  BLUE: "蓝色",
  HUE: "色相",
  SATURATION: "饱和度",
  BRIGHTNESS: "明度",
  OPACITY: "不透明度",
  SELECT_COLOR_PARAM_TYPE: "选参方式",
  COLOR_PREVIEW: "颜色预览"
}
